import * as React from 'react'

import {
  Block,
  CommonBlocksCompoundIndexes,
  ComponentBlock,
  GalleryView,
  InlineView,
  InstanceBlock,
  isComponentBlock,
} from '@basehub/data/replicache/index'
import { getBlockFromColumnId } from '@basehub/data/replicache/schema/block/list/utils'
import { TreeManager } from '@basehub/utils/tree/index'
import { useWorkingTreeStore } from '~/hooks-data/blocks-tree/provider'
import { useTreeSlice } from '~/hooks/use-tree-slice'

export const useThumbnail = ({
  templateId,
  row,
  selectedView,
  treeManager,
}: {
  templateId: ComponentBlock['id']
  row: InstanceBlock | ComponentBlock
  selectedView: InlineView | GalleryView
  treeManager: TreeManager<Block, CommonBlocksCompoundIndexes> | null
}) => {
  const blockTreeManager = useWorkingTreeStore(
    (s) => treeManager ?? s.treeRef.current
  )
  const template = blockTreeManager?.getNode(templateId, {
    required: true,
  }).value

  const thumb = React.useMemo(() => {
    if (!template) return null
    if (!selectedView.thumbnailColumn) return null
    if (!isComponentBlock(template)) return null

    const { block: thumb } = getBlockFromColumnId(
      selectedView.thumbnailColumn,
      { row, treeManager: blockTreeManager }
    )

    return thumb
  }, [row, selectedView, template, blockTreeManager])

  const thumbnailSliced = useTreeSlice(treeManager, (s) => {
    if (!thumb) return null

    return s.getNode(thumb.id)?.value
  })

  return thumbnailSliced ?? '__title'
}
